

/*------------------------------------------------------------------
Helpers
------------------------------------------------------------------*/

const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);
import $ from 'jquery';

import Flickity from './flickity';

let productFlkty;
let productFlktyLarge;

const flickityOptions = {
    prevNextButtons: false,
    freeScroll: false,
    pageDots: false,
    wrapAround: true,
    contain: true
};


if ($('.js-links-slider').length) {
    if ($('.js-links-slider-large').length) {
        setTimeout(() => {
            productFlktyLarge = new Flickity('.js-links-slider-large', flickityOptions);
        }, 4100);
    }

    setTimeout(() => {
        productFlkty = new Flickity('.js-links-slider', flickityOptions);

        let progressBar = document.querySelector('.js-links-slider-progress')
        let carouselStatus = document.querySelector('.js-links-slider-count')

        productFlkty.on('scroll', function (progress) {
            progress = Math.max(0, Math.min(1, progress));
            progressBar.style.width = progress * 100 + '%';
            var slideNumber = productFlkty.selectedIndex + 1;
            carouselStatus.textContent = slideNumber + '/' + productFlkty.slides.length;
        });


        const updateStatus = () => {
            var slideNumber = productFlkty.selectedIndex + 1;
            carouselStatus.textContent = slideNumber + '/' + productFlkty.slides.length;
        };

        updateStatus();



    }, 400);

    /*------------------------------------------------------------------
       Previous Slide
       ------------------------------------------------------------------*/

    [...queryAll('.js-links-slider-prev')].forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            productFlkty.previous();
        });
    });

    /*------------------------------------------------------------------
    Next Slide
    ------------------------------------------------------------------*/

    [...queryAll('.js-links-slider-next')].forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            productFlkty.next();
        });
    });


}
